import { render, staticRenderFns } from "./BaseNavMyExam.vue?vue&type=template&id=6d24c2de&scoped=true&"
import script from "./BaseNavMyExam.vue?vue&type=script&lang=js&"
export * from "./BaseNavMyExam.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavMyExam.vue?vue&type=style&index=0&id=6d24c2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d24c2de",
  null
  
)

export default component.exports